<template>
	<transition name="fade" v-if="config.show">
		<div class="modal-box">
			<div class="modal p-0">
				<div class="modal-header clearfix">
					<h2 class="pull-left">설문문항 등록</h2>
					<a class="close" @click="$emit('close')">&times;</a>
				</div>

				<div class="modal-body p-15" style="min-height: 1px;">
					<div class="input-group clearfix">
						<select v-model="select_category"
							class="form-control-sm m-b-0 pull-left m-r-5"
						>
							<option value="" disabled hidden>대분류</option>
							<option v-for="category in category_list"
									:key="category.surveyCategoryId"
									:value="{ id: category.surveyCategoryId, text: category.name }"
							>
								{{category.name}}
							</option>
						</select>
						<select v-model="select_division"
							class="form-control-sm m-b-0 pull-left m-r-5">
							<option value="" disabled hidden>중분류</option>
							<option v-for="division in division_list"
									:key="division.surveyCategoryId"
									:value="{ id: division.surveyCategoryId, text: division.name }"
							>
								{{division.name}}
							</option>
						</select>
						<select v-model="select_section" class="form-control-sm m-b-0 pull-left" type="text">
							<option value="" disabled hidden>소분류</option>
							<option v-for="section in section_list"
							:value="{ id: section.surveyCategoryId, text: section.name }"
							:key="section.surveyCategoryId">
								{{section.name}}
							</option>
						</select>
					</div>
					<div class="bg-lightgray round p-15 m-t-15">
						<div class="input-group full-width m-b-30 p-b-10 b-b">
							<span class="input-group-addon w100 v-mid p-r-5">
								<select v-model="survey_type"  class="form-control-sm full-width round m-b-0">
									<option value="0">객관식</option>
									<option value="1">주관식</option>
								</select>
							</span>
							<span class="input-group-addon p-r-5">
								<input v-model="item_name" class="form-control-sm full-width text-left round m-b-0" type="text" placeholder="질문을 입력하세요.">
							</span>
						</div>
						<vue-draggable :list="choice_list" handle=".move" v-bind="dragOptions">
							<div v-for="(choice, idx) in choice_list" :key="choice.item_name" class="input-group full-width m-b-10">
								<!-- <span class="input-group-addon w60 v-mid p-r-5">
									<input id="table-check3" class="checkbox4" type="radio" name="dd">
									<label for="table-check3">체크버튼</label>
								</span> -->
								<span v-show="choice.type == 3" class="input-group-addon w60 v-mid p-r-5">기타</span>
								<span :class="{'text-left' : choice.type == survey_type_list[3]}" class="input-group-addon text-left v-mid p-r-5">
									<input v-model="choice.itemName"
									placeholder="보기항목을 입력하세요."
									class="form-control-sm full-width text-left round m-b-0" type="text">
								</span>
								<span class="input-group-addon w80 v-mid">
									<a class="move">이동</a>
									<a @click="removeChoice(idx)" class="del">삭제</a>
								</span>
							</div>
						</vue-draggable>

						<div class="input-group full-width m-b-10">
							<span class="input-group-addon w60 v-mid p-r-5">
							</span>
							<span class="input-group-addon v-mid p-r-5">
								<button @click="addChoice(2)" class="btn-sm full-width round" type="text">항목추가</button>
							</span>
							<span class="input-group-addon p-r-5 v-mid">
								<button @click="addChoice(3)" class="btn-sm full-width round" type="text">기타 항목추가</button>
							</span>
							<span class="input-group-addon w80 v-mid">
							</span>
						</div>
					</div>
				</div>

				<div class="modal-footer p-15 m-t-30 clearfix">
					<button @click="regItem()" class="btn btn-blue round full-width" type="button">등록</button>
				</div>
			</div>
			<modal-alert
			:config="modals.ModalAlert"
			@close="modals.ModalAlert.show=false;"

			:key="hash(modals.ModalAlert)">
			</modal-alert>
		</div>


	</transition>
</template>

<script>
import ModalAlert from '../modals/ModalAlert.vue'

import server from '../statics/server'
import VueDraggable from 'vuedraggable'
import _ from 'lodash'
import moment from 'moment'// eslint-disable-line no-unused-vars
export default {
	name: "ModalSurveyRegister",
	components: {
		VueDraggable,
		ModalAlert
	},
	watch : {
		select_category(item, pre_item){// eslint-disable-line no-unused-vars
			this.getList(item.id, 'division_list');
			if(item != ''){
				this.section_list = [];
				this.select_section = '';
				this.select_division = '';
			}
		},
		select_division(item, pre_item){// eslint-disable-line no-unused-vars
			if(item != '') {
				this.select_section = '';
				this.getList(item.id, 'section_list');
			}
		},
		select_section(item, pre_item){// eslint-disable-line no-unused-vars

		}

	},
	// 미리 계산된 option 값 들
	computed: {
		dragOptions() {
			return {
				ghostClass: "ghost"
			}
		}
	},
	default: function() {
		return {
			name: this.name,
			show: false
		}
	},

	props: {
		config: Object,
	},
	mounted(){
		this.getList( 0, 'category_list');
	},
	data(){
		return {

			modals: {
				ModalAlert: ModalAlert.default(),
			}, // 모달 설정객체 모음

			select_category : '',
			select_division : '',
			select_section : '',

			category_list : [],
			division_list : [],
			section_list : [],

			survey_item_class : {
				parentsId : '',
				surveyCategoryId :'',
				itemName : '',
				type : '',
				regMberId : '',
				regMberName : '',
				deleted : 0,
				regDate : ''
			},
			choice_list : [],
			item_name : '',
			survey_type : 0,
			survey_type_list : ['객관식', '주관식', '보기', '작성보기'],

		}
	},
	methods : {
		getList (parentsId_val, list_name){
			// parentsId_val : 검색할 카테고리 아이디 list_name : 갱신 할 리스트 명
			const self = this;
			let parentsId = parentsId_val || 0;
			server.postAxios('SURVEY_CATEGORY',  { parentsId }, ({data , err}) => {// eslint-disable-line no-unused-vars
				self[list_name] = _.filter(data.list, {parentsId});
				// eslint-disable-next-line
				// console.log('self[list_name] : ', self[list_name])
			});
		},
		checkSetItem(){
			const self = this;

			if(this.select_section == ''){
				// 팝업 창
				this.modals.ModalAlert.show = true;
				this.modals.ModalAlert.msg = '분류를 선택하세요.';
				return false;
			}
			if(this.item_name == ''){
				// 팝업 창
				this.modals.ModalAlert.show = true;
				this.modals.ModalAlert.msg = '질문을 입력하세요.';
				return false;
			}

			if(this.choice_list.length == 0 && this.survey_type == 0){
				// 팝업 창
				this.modals.ModalAlert.show = true;
				this.modals.ModalAlert.msg = '보기항목을 1개 이상 추가하세요.';
				return false;
			}
			let result = true;
			_.forEach(this.choice_list, (choice, idx) => {
				idx;
				if(choice.itemName == ''){
					this.modals.ModalAlert.show = true;
					self.modals.ModalAlert.msg = '비워진 보기항목을 입력하세요.';
					result = false;
				}
			});

			return result;

		},
		addChoice(type){
			this.choice_list.push({
				parentsId : 0,
				surveyCategoryId : this.select_section.id,
				itemName : '',
				type : type,
			});
		},
		regItem (){
			const self = this;
			this.survey_item_class = {
				parentsId : 0,
				surveyCategoryId : this.select_section.id,
				itemName : this.item_name,
				type : this.survey_type_list[this.survey_type],
			}
			// 항목을 등록 후
			// 등록 성공 하면 보기들 순서대로 등록
			if(this.checkSetItem()){
				server.putAxios('SURVEY_ITEM',  this.survey_item_class, ({data}) => {
					// err;
					// {"msg":"성공","list":[{"ord":"11","parentsId":"0","itemName":"test","surveyItemId":null,"regDate":"2019-11-10 16-24:50","regMberId":"","regMberName":"","surveyCategoryId":"4","type":"객관식"}]}
					// eslint-disable-next-line
					if(data.msg == '성공' && self.survey_type == 0){
						let parent_id = data.list[0].surveyItemId || 10;
						_.forEach(self.choice_list, (choice) => {
							// idx;
							_.assignIn(choice, {
									parentsId : parseInt(parent_id),
									surveyCategoryId : self.select_section.id,
									itemName : choice.itemName,
									type : self.survey_type_list[choice.type],
							});
						});
						server.putAxios('SURVEY_ITEM', self.choice_list, ({data}) => {
							// err;
							if(data.msg == '성공'){
								self.config.show = false;
								self.$emit('refresh')
							}
							// eslint-disable-next-line
							// console.log('choice result : ', data);
						})
					}else if(data.msg == '성공' && self.survey_type == 1){
						self.config.show = false;
						self.$emit('refresh');
					}
				});
			}
		},
		removeChoice(list_idx){
			this.choice_list.splice(list_idx, 1);
		},
	}
}
</script>